import  React from 'react';
import { Link } from "@reach/router"
import Layout from "../components/Layout"
import Projects from "../components/Projects"


const aboutPage = () => {
  return (
    <Layout>
      <Projects/>
    </Layout>
    )
}

export default aboutPage;